/**
 * 母亲节产品墙专用：逻辑对齐 `component-buy-button.js`，自定义元素为 `momday-buy-now-button`，
 * 避免与主题 `buy-now-button` 混用或重复定义。
 */
if (!customElements.get("momday-buy-now-button")) {
  class MomdayBuyNowButton extends HTMLElement {
    _shopify_features_script = document.querySelector(
      "script[id='shopify-features']"
    );
    _shopify_features_json = JSON.parse(
      this._shopify_features_script.innerHTML
    );
    _checkout_headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Basic " + btoa(this._shopify_features_json.accessToken),
    };

    get _variantId() {
      return this.getAttribute("data-variant-id");
    }
    get _quantity() {
      return this.getAttribute("data-quantity") ?? 1;
    }

    constructor() {
      super();
      this.loadingSpinner = this.querySelector(".loading__spinner ");
      this._processing = false;
      this._onClick = this.checkout.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this._onClick);
    }

    async checkout() {
      const variantIds = this._variantId.split(",");
      const quantities = this._quantity.split(",");
      if (window.cartGiftSettings) {
        if (this._processing) return;
        await fetch("/cart/clear.js", { method: "POST" });
        let data = JSON.stringify({ id: variantIds[0], quantity: 1 });
        if (variantIds.length > 1) {
          const items = variantIds.map((id, index) => {
            return {
              form_type: "product",
              utf8: "✓",
              id: parseInt(id, 10),
              quantity: parseInt(quantities[index], 10),
            };
          });
          let data_json = {
            items: items,
          };

          data = JSON.stringify(data_json);
        }
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: data,
        });
        const cartRes = await fetch("/cart.js");
        const cart = await cartRes.json();
        if (window.chooseStepGiftForCheckout) {
          await window.chooseStepGiftForCheckout(cart);
        }
        console.log(variantIds);
        window.location.href = "/checkout";
        this._processing = false;
        return;
      }

      const defaultQuantity = quantities[0] || 1;
      if (variantIds.length !== quantities.length) {
        console.warn("变体ID与数量的数量不匹配，将使用相同的数量值。");
        quantities.length = variantIds.length;
        quantities.fill(defaultQuantity);
      }
      this.startLoading();
      this.checkoutByJson(variantIds, quantities)
        .catch((err) => {
          console.error(err);
          console.log(variantIds, quantities);
          this.checkoutByCartUrl(variantIds, quantities);
        })
        .finally(() => this.finishLoading());
    }

    checkoutByCartUrl(variantIds, quantities) {
      let parmaString = "";
      for (let i = 0; i < variantIds.length; i++) {
        const variantId = variantIds[i];
        const quantity = quantities[i];
        if (i == 0) {
          parmaString = `${parmaString}${variantId}:${quantity}`;
        } else {
          parmaString = `${parmaString},${variantId}:${quantity}`;
        }
      }
      const cartRoute = window.routes?.cart_url ?? "/cart";
      const checkoutUrl = `${cartRoute}/${parmaString}`;
      window.location.href = checkoutUrl;
    }

    async checkoutByJson(variantIds, quantities) {
      let lineItems = variantIds.map((id, index) => {
        return {
          variant_id: parseInt(id, 10),
          quantity: parseInt(quantities[index], 10),
        };
      });

      let checkout_json = {
        checkout: {
          line_items: lineItems,
          secret: true,
          wallet_name: "Checkout",
          is_upstream_button: false,
          page_type: "product",
          has_selling_plans: false,
          presentment_currency: window.shop_currency,
          country: window.shop_locale_upcase,
        },
      };
      let data = JSON.stringify(checkout_json);
      return fetch("/wallets/checkouts.json", {
        method: "POST",
        headers: this._checkout_headers,
        body: data,
      })
        .then(function (response) {
          if (response.ok) {
            return response.text();
          }
        })
        .then(function (strj) {
          let checkout_json = JSON.parse(strj);
          location.href = checkout_json.checkout.web_url;
        });
    }

    startLoading() {
      this.setAttribute("aria-disabled", true);
      this.classList.add("loading");
      this.loadingSpinner?.classList.remove("hidden");
    }

    finishLoading() {
      this.removeAttribute("aria-disabled");
      this.classList.remove("loading");
      this.loadingSpinner?.classList.add("hidden");
    }
  }

  customElements.define("momday-buy-now-button", MomdayBuyNowButton);
}
